module.exports = __webpack_public_path__ + "img/map.ee1a950e.jpg";